import React from 'react';
import { SUPPORT } from '../../config';

/**
 * Displays a "more details" small message
 */
export function Details() {
    return (
        <div className="w3-small">
            For further information, please contact
            the <a href={`mailto:${SUPPORT}`} rel="noreferrer" title="Did you find a bug?">Auditum / Prodatec support</a>.
        </div>
    );
}
